import React from 'react';
import { brand, disclaimer, productName } from '../data/content';
export function Footer() {
  return <footer className="border-t border-ink-line bg-ink pb-28 lg:pb-14" data-id="element-76" data-mp="3gfitoga0y7d2">
      <div className="mx-auto max-w-content px-6 pt-10 text-center" data-id="element-77" data-mp="32nuh6bvv5gvk">
        <p className="font-sans text-xs font-bold uppercase tracking-[0.22em] text-mustard" data-id="element-78" data-mp="32pp39tivff18">{brand}</p>
        <p className="mx-auto mt-4 max-w-lg font-sans text-xs leading-relaxed text-ivory/60" data-id="element-79" data-mp="36nd57gize82m">{disclaimer}</p>
        <p className="mt-6 font-sans text-xs leading-relaxed text-ivory/50" data-id="element-80" data-mp="3ud7gvurkdqla">
          © {brand} 2026 · {productName} — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}